import { DynamicDetailsListItemRowData } from 'app/shared/dynamic-details-list/dynamic-details-list-item-row-data';
import { ViewModel } from 'app/viewmodels/view-model';

export class DynamicDetailsListItemAdapter {
  constructor(public name: string, public detailsItem: ViewModel, public rowData: DynamicDetailsListItemRowData[]) {
  }
}
